import gql from 'graphql-tag';

export const getData = gql`
   query DATA {
      asesores {
         codigo
         nombre
         apPaterno
         apMaterno
      }
      tipoAtenciones {
         codigo
         denominacion
         concurrencia
         color
      }
      tipoServicios {
         codigo
         denominacion
      }
      productos {
         codigo
         denominacion
      }
   }
`;


export const getProducto = gql`
   query ProductoCliente($codigoCliente: String!) {
      clienteProductosFiltro(cliente: $codigoCliente) {
         producto {
            codigo
            denominacion
            activo
         }
         fechaHora
      }
   }
`;

export const getDisponibilidad=gql`
query Disponibilidad($fecha:DateTime!,$dia:Int!){
      ConsultaAsesorLibre(fecha:$fecha,dia:$dia,,esIntranet:1){
        codigo
        nombre
        apPaterno
        apMaterno
        especialidad
        sucursal {
            codigo
         }
      }
 }
`;

export const getActividades = gql`
   query AtencionActividades($codigoAtencion: String!) {
      tipoActividadesFiltro(atencion: $codigoAtencion) {
         codigo
         denominacion
         descripcion
         observaciones
         duracionAproximada
      }
   }
`;

export const programarAtencion = gql`
   mutation ProgramarAtencion(
      $atencion: AtencionInput!
      $atencionDetalle: [AtencionDetalleInput]
      $atencionEjecutada: [AtencionEjecutadaInput]
   ) {
      programarAtencion(
         atencion: $atencion
         atencionDetalle: $atencionDetalle
         atencionEjecutada: $atencionEjecutada
      ) {
         codigo
      }
   }
`;

export const getEnviarEmail = gql`
query getEnviarEmail( $email:[String]!,
                     $razonSocial:String!,
                     $asesor:String!,
                     $codigoAtencion:String,
                     $ruc:String,
                     $fechaHoraInicio:DateTime,
                     $fechaHoraFin:DateTime,
            )
      {
         enviarMailProgramarAtencion(  email:$email,
                                          razonSocial:$razonSocial,
                                          asesor:$asesor,
                                          codigoAtencion:$codigoAtencion,
                                          ruc:$ruc,
                                          fechaHoraInicio:$fechaHoraInicio,
                                          fechaHoraFin:$fechaHoraFin,
                     ) 
            {
               msg
            }
      }
`;


export const verificarHorarioQuery = gql`
   query Data ($codCliente: String!, $fechaHoraInicio: DateTime!, $fechaHoraFinal: DateTime!){
      cruceHorarioAtencioDetalle(codCliente: $codCliente, fechaHoraInicio: $fechaHoraInicio, fechaHoraFinal: $fechaHoraFinal){
         atencion
         fechaHoraInicio
         fechaHoraFinal
      }
   }
`;